import * as React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Chip,
    Box,
    Typography
} from '@mui/material';
import i18n from '../../i18n';
import { formatCurrency } from '../../utils/formatNumber';

export default function DiffTable({ rows }) {
    // Example data
    // const rows = [
    //     {
    //         uuid: '4cad9cac-e14e-465c-a398-eeeda3a80a5f',
    //         ourAmount: 200500,
    //         ourStatus: 'cancelled',
    //         theirAmount: 200500,
    //         theirStatus: 'success',
    //     },
    //     {
    //         uuid: '9e5b4521-e07e-410e-9c7d-22d220108c95',
    //         ourAmount: null,
    //         ourStatus: null,
    //         theirAmount: 200500,
    //         theirStatus: 'charged',
    //     },
    // ];

    const safeRows = Array.isArray(rows) ? rows : [];

    const renderStatusChip = (status) => {
        if (!status) return <Chip label="—" variant="outlined" color="default" />;
        const colorMap = {
            success: 'success',
            cancelled: 'error',
            charged: 'warning',
        };
        return (
            <Chip
                label={status}
                color={colorMap[status] || 'default'}
                variant="outlined"
                size="small"
                sx={{ textTransform: 'capitalize' }}
            />
        );
    };
    const renderAmount = (value) => {
        if (value === null || isNaN(value)) {
            return '—';
        }
        try {
            return formatCurrency(value);
        } catch (e) {
            console.error('Error formatting amount:', e);
            return value;
        }
    };

    if (!safeRows.length) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: 120,
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 1,
                    bgcolor: 'background.neutral',
                }}
            >
                <Typography variant="body2" color="text.secondary">
                    {i18n.t('text.noData') || 'No data available'}
                </Typography>
            </Box>
        );
    }

    return (
        <TableContainer component={Paper} elevation={3}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell><strong>{i18n.t('columns.uuid')}</strong></TableCell>
                        <TableCell align="right"><strong>{i18n.t('columns.ourAmount')}</strong></TableCell>
                        <TableCell align="center"><strong>{i18n.t('columns.ourStatus')}</strong></TableCell>
                        <TableCell align="right"><strong>{i18n.t('columns.theirAmount')}</strong></TableCell>
                        <TableCell align="center"><strong>{i18n.t('columns.theirStatus')}</strong></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {safeRows.map((row) => {
                        const key = row?.uuid || Math.random().toString(36).substring(2, 9);

                        return (
                            <TableRow key={key} hover>
                                <TableCell>{row?.uuid || '—'}</TableCell>
                                <TableCell align="right">{renderAmount(row?.ourAmount)}</TableCell>
                                <TableCell align="center">{renderStatusChip(row?.ourStatus)}</TableCell>
                                <TableCell align="right">{renderAmount(row?.theirAmount)}</TableCell>
                                <TableCell align="center">{renderStatusChip(row?.theirStatus)}</TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
